import { useMemo } from 'react'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export function useHistoryContent() {
  const { t } = useTranslate('about')
  return useMemo(
    () => [
      {
        image: {
          alt: 'Skip Scene',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1722352750/angel-studios/about/Angel_Studios_About_Page_2012',
        },
        year: '2012',
        body: (
          <Translate t={t} i18nKey="historyBlurb2012">
            While brainstorming about the endless customization made possible by the internet, Neal, Daniel, and Jeffrey
            Harmon asked themselves why there wasn’t a way to skip “that one scene” in movies where their mother used to
            reach for the remote. That night, Neal wrote software to skip violent boxing scenes and mute offensive
            language while streaming <i>Cinderella Man</i>. Later, they watched the movie together as a family to teach
            his oldest son about honesty.
          </Translate>
        ),
      },
      {
        image: {
          alt: 'VidAngel Player',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1722352786/angel-studios/about/Angel_Studios_About_Page_2013',
        },
        year: '2013',
        body: (
          <Translate t={t} i18nKey="historyBlurb2013">
            After discovering that nearly half of American parents desired a pre-programmed remote to control content
            while streaming movies, the Harmon brothers—Neal, Daniel, Jeffrey, Jordan, and their cousin, Benton
            Crane—were inspired to launch VidAngel. They recognized the potential of this technology to not only attract
            a significant audience but to eventually establish a superior studio to what Hollywood then offered.
          </Translate>
        ),
      },
      {
        image: {
          alt: 'VidAngel & Hollywood',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1722352730/angel-studios/about/Angel_Studios_About_Page_2016-Option_2',
        },
        year: '2016',
        body: (
          <Translate t={t} i18nKey="historyBlurb2016v3">
            Disney and other studios sued VidAngel for copyright infringement, or in other words, for failing to get
            permission for their technology. VidAngel argued that the Family Movie Act of 2005 was passed because the
            studios would never give permission. In five days, VidAngel raised over $10 million from customers and
            parents to help fight the lawsuit. <br />
            <br /> On December 12, the Los Angeles judge ordered VidAngel to shut down while the lawsuit proceeded on
            the night before the company’s Christmas party. The party was to be held in the company’s brand-new offices,
            which had replaced an old bar and dance club. The team decided to stay up all night, inviting the press to
            an impromptu announcement. They revealed plans to transform the new place into <i>Dry Bar Comedy</i> with
            plans to launch a studio.
          </Translate>
        ),
      },
      {
        image: {
          alt: 'The Chosen Crowdfund Season 1',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1722352910/angel-studios/about/Angel.com_about_2017-2019',
        },
        year: '2017-2019',
        body: (
          <Translate t={t} i18nKey="historyBlurb2017-2019v2">
            VidAngel built the strategy and structure to help <i>The Chosen</i> use equity crowdfunding to finance
            Season 1 of <i>The Chosen</i>, a multi-season television series about the life of Jesus and his disciples.
            With Angel leading the marketing, they helped <i>The Chosen</i> raise over $11 million from over 18,000
            Angel investors, making it the largest crowdfunding amount for a TV show at that time. Angel Studios truly
            bet the farm on <i>The Chosen</i>, investing over $10 million in ads, cash, and employee salaries into
            helping raise capital and launching <i>The Chosen</i>, more than two years before the show finally started
            cash flowing. <br />
            <br />
            Disney got the highest per title copyright judgment in history and asked the bankruptcy court to shut
            VidAngel down, but the Utah bankruptcy judge saw promise in VidAngel’s new studio business. <br />
            <br />
            VidAngel invented Pay it Forward and <i>The Chosen</i> began to grow.
          </Translate>
        ),
      },
      {
        image: {
          alt: 'Handshake Deal',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1722352915/angel-studios/about/Angel.com_about_2020',
        },
        year: '2020',
        body: (
          <Translate t={t} i18nKey="historyBlurb2020v2">
            After filing an appeal and exploding in growth during COVID lockdowns, VidAngel and Disney reached a
            settlement in the lawsuit.
          </Translate>
        ),
      },
      {
        image: {
          alt: 'Angel Studios Rebranding',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1722352791/angel-studios/about/Angel.com_about_2021',
        },
        year: '2021',
        body: (
          <Translate t={t} i18nKey="historyBlurb2021v2">
            The company rebranded as Angel Studios, shifting its focus from identifying and skipping bad stuff in
            Hollywood stories to finding and distributing the very best stuff as a brand-new studio and streaming
            service. Angel Studios, previously VidAngel, was officially launched.
          </Translate>
        ),
      },
      {
        image: {
          alt: 'Tuttle Twins and The Wingfeather Saga',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1722352958/angel-studios/about/2022',
        },
        year: '2022',
        body: (
          <Translate t={t} i18nKey="historyBlurb2022v2">
            Angel Studios partnered with <i>Tuttle Twins</i>, an animated series based on the book series, to raise $4.6
            million through equity crowdfunding. Angel also partnered with <i>The Wingfeather Saga</i> to raise $5
            million through crowdfunding for an animated adaptation of the fantasy book series.
          </Translate>
        ),
      },
      {
        image: {
          alt: 'His Only Son, Sound of Freedom, and The Shift Theatrical Releases',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1722352954/angel-studios/about/2023',
        },
        year: '2023',
        body: (
          <Translate t={t} i18nKey="historyBlurb2023v4">
            <i>His Only Son</i> was the first film to utilize the Pay it Forward platform for a theatrical release in
            film history. It reached #3 in the box office opening weekend, which paved the way for Angel Studios’ place
            in the film industry. <i>Sound of Freedom</i>, the #1 film on July 4th, became one of the highest-grossing
            independent films of all time with over $250 million at the box-office. Angel launched its first original
            film <i>The Shift</i>, also announcing a first-look deal with Neal McDonough.
          </Translate>
        ),
      },
      {
        image: {
          alt: 'His Only Son & Sound of Freedom Theatrical Releases',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1722352930/angel-studios/about/2024',
        },
        year: '2024',
        body: (
          <Translate t={t} i18nKey="historyBlurb2024v2">
            Angel launched the industry’s first on-demand pricing and flexible booking for movie tickets. <i>Cabrini</i>{' '}
            launched as Angel’s first Certified Fresh film on Rotten Tomatoes, earning a 90% critic score and a 98%
            audience score. Director Alejandro Monteverde (<i>Sound of Freedom</i>, <i>Cabrini</i>) signed a 10-year,
            five-film deal with Angel Studios. The momentum continued with{' '}
            <i>Sound of Hope: The Story of Possum Trot</i>, which premiered on the one-year anniversary of{' '}
            <i>Sound of Freedom</i>, highlighting foster care and adoption as a solution to child trafficking. <br />
            <br />
            Angel also introduced <i>Sight</i>, the inspiring true story of Dr. Ming Wang’s journey from poverty in
            China to becoming a world-renowned eye surgeon; <i>Bonhoeffer</i>, a gripping biographical drama about the
            theologian who stood against the Nazis; and <i>Homestead</i>, a thrilling dystopian tale of faith and
            survival in a world on the brink of collapse. With these projects and more, Angel continues to redefine the
            future of entertainment.
          </Translate>
        ),
      },
      {
        image: {
          alt: 'Angel Guild Background Overlay',
          src: '/w_650,g_center,q_auto:eco,f_webp/v1719870719/angel-app/assets/featured/guild-pi.webp',
        },
        year: '2025',
        body: (
          <Translate t={t} i18nKey="historyBlurb2025v2">
            Angel is just getting started. In 2025, we’re bringing more groundbreaking stories to audiences worldwide.{' '}
            <i>Rule Breakers</i> will shine a light on the true story of an all-female robotics team from Afghanistan
            who defied expectations. <i>The King of Kings</i> will reintroduce audiences to the greatest story ever told
            with breathtaking animation. <i>The Last Rodeo</i> will deliver heart and humor in a Western drama about
            family, redemption, and second chances. And <i>Gabriel and the Guardians</i> will mark a bold new chapter
            for Angel, bringing anime-inspired storytelling to our growing library of faith-filled entertainment.
            <br />
            <br />
            As we expand our slate of films and series, the Angel Guild continues to shape the future of entertainment.
            This year, we reached an incredible milestone—one million Angel Guild members. That’s one million people
            coming together to fund and support stories that amplify light. With this passionate community leading the
            way, the best is yet to come.
          </Translate>
        ),
      },
    ],
    [t],
  )
}
